import request from '@/api/request'
// ************************************************************************
// **************************** 项目相关 ************************************
// ************************************************************************
// C端销售查询项目
export function queryCourseBySeller (data) {
  // const { name, type, directionId, professionId, page, limit } = data
  return request({ url: '/course/query/summary/sell', method: 'post', data })
}
// 获取机构
export function getOrganization (data) {
  // const { name, type, directionId, professionId, page, limit } = data
  return request({ url: '/organization/query', method: 'post', data })
}
// 获取专业
export function queryFitPorfessional (data) {
  return request({ url: '/fitPorfessional/query', method: 'post', data })
}
// course - 2，查询项目列表
export function queryCourseList (data) {
  return request({ url: '/course/query/summary/KA', method: 'post', data })
}
// course - 2，查询项目详情
export function queryCourseDetail (id) {
  return request({ url: '/course/query/detail', method: 'post', data: { id } })
}

export function getCourseListAdmin (data) {
  // const { limit, page, name, type, isOnline, orderByUpdated } = data
  return request({ url: '/course/query/summary/KA', method: 'post', data })
}

export function querySummary (data) {
  return request({ url: '/territory/query/summary', method: 'post', data })
}
// ************************************************************************
// **************************** 工单相关 ************************************
// ************************************************************************
// 获取所有的总监
export function getProducorLeader () {
  return request({ url: '/user/query/producorLeader', method: 'post', data: {} })
}

// 获取老师的信息
export function getTeacher () {
  return request({ url: '/teacher/query', method: 'post', data: {} })
}
// 创建工单
export function createOrder (data) {
  return request({ url: '/workOrder/create', method: 'post', data })
}
// 查询所有工单
export function queryWordOrder (data) {
  // const { name, status, limit, page } = data
  return request({ url: '/workOrder/query/summary/KA', method: 'post', data })
}
// 查询工单详情
export function getOrderDetail (data) {
  // const { name, status, limit, page } = data
  return request({ url: '/workOrder/query/detail', method: 'post', data })
}
// 查询老师
export function queryTeacher (data) {
  // const { name, status, limit, page } = data
  return request({ url: '/teacher/query', method: 'post', data })
}

// 撤回工单
export function recallOrder (orderId) {
  return request({ url: '/workOrder/recall', method: 'post', data: { orderId } })
}
// 闲置工单
export function idleOrder (id) {
  return request({ url: '/workOrder/idle', method: 'post', data: { id } })
}

// 查看数据统计
export function staticKaData () {
  return request({ url: '/statistics/search/KA', method: 'post', data: {} })
}

// ************************************************************************
// **************************** 登录相关 ************************************
// ************************************************************************
// 登录操作
export function login (userName, password) {
  return request({ url: '/user/login', method: 'post', data: { userName, password } })
}
// 获取logo
export function getLogo () {
  return request({ url: '/user/getLogo', method: 'post', data: {} })
}
// 登录检测
export function checkLogin () {
  return request({ url: '/user/checkLogin', method: 'get', data: {} })
}
// 注销登录
export function logout () {
  return request({ url: '/user/logout', method: 'get', data: {} })
}
// @@@@@@@@@@@@@@@@@@@@@@KA@@@@@@@@@@@@@@@@@@@@@@@@@@
// 获得源项目
export function getKaCopyCourse (data) {
  return request({ url: '/kaCourse/copyCourse/query/summary', method: 'post', data })
}

// 保留 、 不保留 /kaCourse/newCourse/setCopyOfCourse
export function kaNewCourseAction (data) {
  return request({ url: '/kaCourse/newCourse/setCopyOfCourse', method: 'post', data })
}

// ka消息的接口
export function getKaMessage (data) {
  return request({ url: '/kaCourse/message/query', method: 'post', data })
}

// 设置消息已读
export function setMessageRead (id) {
  return request({ url: '/kaCourse/message/setRead', method: 'post', data: { id } })
}

// 获得新项目
export function getKaNewCourse (data) {
  return request({ url: '/kaCourse/newCourse/query/summary', method: 'post', data })
}

// 删除项目
export function deleteKaCopyCourse (data) {
  return request({ url: '/kaCourse/copyCourse/delete', method: 'post', data })
}

// 获取当前课程已经上架的机构的列表 /kaCourse/copyCourse/query/putawayList
export function getKaCopyCoursePublishList (data) {
  return request({ url: '/kaCourse/copyCourse/query/putawayList', method: 'post', data })
}

// 获取当前课程已经上架的机构的ids /kaCourse/copyCourse/query/putawayList
export function getCoursePublishOrg (data) {
  return request({ url: '/kaCourse/copyCourse/query/putawayList', method: 'post', data })
}

// 获取机构课程 列表  /kaCourse/organization/query/summay
export function getOrgCourseList (data) {
  return request({ url: '/kaCourse/organization/query/summay', method: 'post', data })
}

// 下架项目
// /kaCourse/organization/offShelves
export function unPublishProject (data) {
  return request({ url: '/kaCourse/organization/offShelves', method: 'post', data })
}

// /kaCourse/organization/query/detail 获得机构课程详情

export function getOrgCourseDetail (data) {
  return request({ url: '/kaCourse/organization/query/detail', method: 'post', data })
}

// 修改机构项目 /kaCourse/organization/edit
export function updateOrgCourse (data) {
  return request({ url: '/kaCourse/organization/edit', method: 'post', data })
}

export function queryHotCourse () {
  return request({ url: '/course/hot/query', method: 'post' })
}

// 适合专业的搜索
export function fitPorfessionalQuery (id) {
  return request({ url: '/fitPorfessional/query', method: 'post', data: { id } })
}

// 获取分享界面课程信息
// /course/query/share

export function getSharePage (id, isQrcode, isCollegesH5Map) {
  let obj = {}
  if (isCollegesH5Map) {
    obj = { id, isQrcode, isCollegesH5Map }
  } else {
    obj = { id, isQrcode }
  }
  return request({ url: '/course/query/share', method: 'post', data: obj })
}

// 导出pdf
export function getPdf (data) {
  return request({ url: '/course/query/share/pdfByHtml', method: 'post', data })
}

// 获取渠道
export function getChannel (data) {
  return request({ url: '/channel/queryOne', method: 'post', data })
}

// 下载附件
export function generateCourseNewAttachmentUrl (data) {
  return request({ url: '/course/generateCourseNewAttachmentUrl', method: 'post', data })
}
